import React from "react";

export function WB_CoreHorizontalDivider({}) {
    return <div className="my-2">
<div className="h-px bg-gray-300 w-full" />
    </div>
}